
// import React, { useEffect, useState } from "react";
// // import "../css/OrderIssue.css";
// import { useParams, useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// const API = "https://api.mahal.qa/api/v1/orders";

// export default function OrderIssue() {
//   const [orderItems, setOrderItems] = useState([]);

//   const { orderId } = useParams();
//   const navigate = useNavigate();
//   const [issue, setIssue] = useState(null);
//   const [issueType, setIssueType] = useState("Missing Items");
//   const [desc, setDesc] = useState("");
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // ✅ MULTI PRODUCT SELECTION
//   const [selectedProducts, setSelectedProducts] = useState([]);

//   const token = localStorage.getItem("token");

//   const previewIssueId = `IR-${new Date().getFullYear()}-${String(orderId).slice(-4)}`;
//   const previewReportedAt = new Date().toISOString();
//   const { t, i18n } = useTranslation();

//   const formatNumber = (value) => {
//   return new Intl.NumberFormat(
//     i18n.language === "ar" ? "ar-QA" : "en-US"
//   ).format(value);
// };

// const formatOrderId = (id) => {
//   if (i18n.language !== "ar") return id;

//   return id.replace(/\d/g, (d) =>
//     new Intl.NumberFormat("ar-QA").format(d)
//   );
// };

//  // ===============================
// // LOAD ISSUE (IF EXISTS)
// // ===============================
// useEffect(() => {
//   setLoading(true);

//   fetch(`${API}/${orderId}/issue`, {
//     headers: { Authorization: `Bearer ${token}` }
//   })
//     .then(res => res.json())
//     .then(data => {
//       if (data && data.issue_report_id) {
//         setIssue({
//           ...data,
//           damaged_products: data.damaged_products || [],
//           issue_images: data.issue_images || []
//         });
//       } else {
//         setIssue(null);
//       }
//     })
//     .catch(() => setIssue(null))
//     .finally(() => setLoading(false));
// }, [orderId, token]);


//   // ===============================
//   // IMAGE HANDLERS
//   // ===============================
//   const handleImageChange = e => {
//     const files = Array.from(e.target.files);
//     if (!files.length) return;
//     setImages(prev => [...prev, ...files]);
//   };

//   const removeImage = index => {
//     setImages(prev => prev.filter((_, i) => i !== index));
//   };

//   // ===============================
//   // PRODUCT HANDLERS
//   // ===============================
//   const handleProductSelect = e => {
//   const value = String(e.target.value);
//   if (!value) return;

//   setSelectedProducts(prev =>
//     prev.includes(value) ? prev : [...prev, value]
//   );

//   e.target.value = "";
// };


//   const removeProduct = product => {
//     setSelectedProducts(prev => prev.filter(p => p !== product));
//   };

//   // ===============================
//   // SUBMIT ISSUE
//   // ===============================
//   const submitIssue = async () => {
//     if (!desc.trim()) {
//       alert(t("resdescribe_issue_error"));
//       return;
//     }

//     if (!selectedProducts.length) {
//      alert(t("resselect_product_error"));
//       return;
//     }

//     const formData = new FormData();
//     formData.append("issue_type", issueType);
//     formData.append("description", desc);

//     selectedProducts.forEach(p => {
//       formData.append("products", p);
//     });

//     images.forEach(file => {
//       formData.append("images", file);
//     });

//     const res = await fetch(`${API}/${orderId}/issue`, {
//       method: "POST",
//       headers: { Authorization: `Bearer ${token}` },
//       body: formData
//     });

//     if (!res.ok) {
//       alert(t("resissue_failed"));
//       return;
//     }

//     const result = await res.json();

//     // ✅ FIX: store product_name immediately after submit
//     setIssue({
//       issue_report_id: result.issue_report_id,
//       issue_type: issueType,
//       description: desc,
//       status: "UNDER_REVIEW",
//       reported_at: new Date().toISOString(),
//       damaged_products: selectedProducts.map(p => ({
//         product_id: p,
//         product_name: p

//       })),
//       issue_images: images.map(file => URL.createObjectURL(file))
//     });

//     setImages([]);
//     setDesc("");
//     setSelectedProducts([]);
//   };

//   useEffect(() => {
//   if (!orderId) return;

//   fetch(
//     `https://api.mahal.qa/api/v1/orders/restaurant/orders/${orderId}`,
//     {
//       headers: { Authorization: `Bearer ${token}` }
//     }
//   )

//     .then(res => res.json())
//     .then(data => {
//       console.log("ORDER ITEMS:", data);
//       setOrderItems(data.items || []);
//     })
//     .catch(() => setOrderItems([]));
// }, [orderId, token]);


//   if (loading) {
//     return <div className="oi-page">Loading...</div>;
//   }



// //   useEffect(() => {
// //   if (!orderId) return;

// //   fetch(`${API}/${orderId}`, {
// //     headers: { Authorization: `Bearer ${token}` }
// //   })
// //     .then(res => res.json())
// //     .then(data => setOrderItems(data.items || []))
// //     .catch(() => setOrderItems([]));
// // }, [orderId, token]);

//  return (
//   <div className="dashboard_page order_issue_page">

//     {/* HEADER */}
//     <div className="page_header">
//         <h2>



//           {t("resorder_issue_details")}
//         </h2>
//         <button className="btn_add_item_v2" onClick={() => navigate(-1)}>
//        ← {t("resback_to_orders")}
//       </button>
//       </div>
    

//     {/* SUMMARY STRIP */}
//     {/* <div className="issue_summary_strip">
//       <div>
//         <label>{t("resissue_report_id")}</label>
//         {formatOrderId(issue ? issue.issue_report_id : previewIssueId)}
//       </div>

//       <div>
//         <label>{t("resorder_id")}</label>
//         <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
//         {formatOrderId(orderId)}
//       </span>
//       </div>

//       <div>
//         <label>{t("resreported_on")}</label>
//         <span>
//           {new Date(issue?.reported_at || previewReportedAt).toLocaleString(i18n.language === "ar" ? "ar-QA" : "en-US")}
//         </span>
//       </div>
//     </div> */}




//      <div className="section_card soft mb-3">
//        <div className="row">
//         {/* issue_report_id */}
//           <div className="col-md-4">
//             <div className="grn-info-item">
//               <div className="grn-info-icon supplier">
//                 <i className="far fa-file-alt"></i>
//               </div>

//               <div className="grn-info-content">
//                 <small className="muted">
//                   {t("resissue_report_id")}
//                 </small>

//                 <div className="grn-info-value">
//                    {formatOrderId(issue ? issue.issue_report_id : previewIssueId)}
//                 </div>
//               </div>
//             </div>
            
//           </div>

//       {/* order_id */}
//           <div className="col-md-4">
//             <div className="grn-info-item">
//               <div className="grn-info-icon user">
//                 <i className="fas fa-dice-d6"></i>
//               </div>

//               <div className="grn-info-content">
//                 <small className="muted">
//                   {t("resorder_id")}
//                 </small>

//                 <div className="grn-info-value" dir="ltr" style={{ unicodeBidi: "isolate" }}>
//                   {formatOrderId(orderId)}
//                 </div>
//               </div>
//             </div>
//           </div>
//            {/* reported_on */}
//              <div className="col-md-4">
//             <div className="grn-info-item">
//               <div className="grn-info-icon date">
//                 <i className="far fa-calendar-alt"></i>
//               </div>

//               <div className="grn-info-content">
//                 <small className="muted">
//                   {t("resreported_on")}
//                 </small>

//                 <div className="grn-info-value">
//                   {new Date(issue?.reported_at || previewReportedAt).toLocaleString(i18n.language === "ar" ? "ar-QA" : "en-US")}
//                 </div>
//               </div>
//             </div>
//           </div>
//       </div>
//     </div>

//     {/* MAIN CONTENT */}
//     <div className="row mt-4">

//          {/* LEFT PANEL */}
//       <div className="col-md-8">
//         <div className="card issue_card">
//           <div class="grn-info-item detail-row">
//               <div class="grn-info-icon supplier">
//                 <i class="fas fa-file-medical-alt"></i>
//               </div>
//               <div class="grn-info-content">
//                 <div class="grn-info-value">{t("resissue_information")}
//                 </div>
//               </div>
//             </div>

//           {!issue && (
//             <>
//               <div className="summary_item detail-row">
//               <i class="fas fa-cube" aria-hidden="true"></i>
//               <div>
//                 <p>{t("resissue_type")}:</p>
// 		          <select
//                   className="form-select"
//                   value={issueType}
//                   onChange={(e) => setIssueType(e.target.value)}
//                 >
//                   <option>{t("resmissing_items")}</option>
//                   <option>{t("resdamaged_items")}</option>
//                   <option>{t("reswrong_items")}</option>
//                 </select>
//               </div>
//             </div>

//             <div className="summary_item detail-row ">
//               <i class="fas fa-bolt" aria-hidden="true"></i>
//               <div>
//                 <p>{t("resdamaged_products")}:</p>
// 		            <select
//                   className="form-select"
//                   onChange={handleProductSelect}
//                 >
//                   <option value="">{t("resselect_product")}</option>
//                   {orderItems.map((item) => (
//                     <option
//                       key={item.product_name_english}
//                       value={item.product_name_english}
//                     >
//                         {i18n.language === "ar"
//                           ? item.product_name_arabic || item.product_name_english
//                           : item.product_name_english}
//                     </option>
//                   ))}
                  
//                 </select>
               
//                    {selectedProducts.length > 0 && (
//                 <div className="oi-selected-products mb-3">
//                   {selectedProducts.map((pid, idx) => {
//                     const product = orderItems.find(
//                       (i) => i.product_name_english === pid
//                     );

//                     return (
//                       <span key={idx} className="oi-product-chip">
//                         {product
//                           ? (i18n.language === "ar"
//                               ? product.product_name_arabic || product.product_name_english
//                               : product.product_name_english)
//                           : pid}
//                         <button
//                           type="button"
//                           onClick={() => removeProduct(pid)}
//                         >
//                           ✕
//                         </button>
//                       </span>
//                     );
//                   })}
//                 </div>
//               )}
//               </div>
//             </div>

//               {/* <div className="summary_item detail-row">
//                 <label className="form-label">{t("resdamaged_products")}</label>
//                 <select
//                   className="form-select"
//                   onChange={handleProductSelect}
//                 >
//                   <option value="">{t("resselect_product")}</option>
//                   {orderItems.map((item) => (
//                     <option
//                       key={item.product_name_english}
//                       value={item.product_name_english}
//                     >
//                         {i18n.language === "ar"
//                           ? item.product_name_arabic || item.product_name_english
//                           : item.product_name_english}
//                     </option>
//                   ))}
//                 </select>
//                    {selectedProducts.length > 0 && (
//                 <div className="oi-selected-products mb-3">
//                   {selectedProducts.map((pid, idx) => {
//                     const product = orderItems.find(
//                       (i) => i.product_name_english === pid
//                     );

//                     return (
//                       <span key={idx} className="oi-product-chip">
//                         {product
//                           ? (i18n.language === "ar"
//                               ? product.product_name_arabic || product.product_name_english
//                               : product.product_name_english)
//                           : pid}
//                         <button
//                           type="button"
//                           onClick={() => removeProduct(pid)}
//                         >
//                           ✕
//                         </button>
//                       </span>
//                     );
//                   })}
//                 </div>
//               )}

//               </div> */}

           
//               <div className="mb-4">
//                 <label className="form-label">{t("resdescription")}</label>
//                 <textarea
//                   className="form-control"
//                   rows="4"
//                    placeholder={t("resdescribe_issue")}
//                   value={desc}
//                   onChange={(e) => setDesc(e.target.value)}
//                 ></textarea>
//               </div>

              
//               <div className="mb-3">
//                 <input
//                   id="issueImage"
//                   type="file"
//                   accept="image/*"
//                   multiple
//                   className="d-none"
//                   onChange={handleImageChange}
//                 />

//                 <button
//                   type="button"
//                   className="choose_file_btn"
//                   onClick={() =>
//                     document.getElementById("issueImage").click()
//                   }
//                 >
//                   <i className="fa fa-camera me-2"></i>
//                   {t("resadd_photos")}
//                 </button>
//               </div>

//               {images.length > 0 && (
//                 <div className="oi-image-preview mb-3">
//                   {images.map((file, idx) => (
//                     <div key={idx} className="oi-image-thumb">
//                       <img
//                         src={URL.createObjectURL(file)}
//                         alt={`preview-${idx}`}
//                       />
//                       <button
//                         type="button"
//                         className="oi-image-remove"
//                         onClick={() => removeImage(idx)}
//                       >
//                         ✕
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               <div className="action_buttons d-flex">
//                 <button className="btn btn-orange" onClick={submitIssue}>
//                   <i className="fa fa-paper-plane me-2"></i>
//                   {t("ressubmit_issue")}
//                 </button>
//               </div>
//             </>
//           )}

//           {issue && (
//             <div className="oi-issue-view">

             
//                <div className="summary_item detail-row">
//               <i class="fas fa-cube" aria-hidden="true"></i>
//               <div>
//                 <p>{t("resproducts")}:</p>
// 		         {issue.damaged_products.map((p, idx) => {
//                     const product = orderItems.find(
//                       (i) => i.product_id === p.product_id
//                     );

//                     const name =
//                       i18n.language === "ar"
//                         ? product?.product_name_arabic || product?.product_name_english
//                         : product?.product_name_english ;

//                     return (
//                       <span key={idx} className="oi-product-chip">
//                         {name}
//                       </span>
//                     );
//                   })}
//               </div>
//             </div>

//                <div className="summary_item detail-row">
//               <i class="fas fa-comment-dots" aria-hidden="true"></i>
//               <div>
//                 <p >{t("resdescription")}:</p>
// 		         <p>{issue.description}</p>
//               </div>
//             </div>

//               {issue.issue_images
//                 ?.filter((img) => typeof img === "string" && img.length > 0)
//                 .length > 0 && (
//                 <div >
//                   {issue.issue_images
//                     .filter((img) => typeof img === "string" && img.length > 0)
//                     .map((img, idx) => (
//                       <div key={idx} className="oi-image-thumb">
//                         <img
//                           src={
//                             img.startsWith("blob:")
//                               ? img
//                               : `data:image/jpeg;base64,${img}`
//                           }
//                           alt={`issue-${idx}`}
//                         />
//                       </div>
//                     ))}
//                 </div>
//               )}

//               {issue.status !== "UNDER_REVIEW" && (
//                 <div className="oi-field oi-supplier-response mt-3">
//                  <h6>{t("ressupplier_response")}</h6>

//                   {issue.action && (
//                     <p>
//                       <b>{t("resaction")}:</b> {issue.action}
//                     </p>
//                   )}

//                   {issue.refund !== null && (
//                     <p>
//                       <b>{t("resrefund")}:</b> ${formatNumber(issue.refund)}
//                     </p>
//                   )}

//                   {issue.notes && (
//                     <p>
//                       <b>{t("resnotes")}:</b> {issue.notes}
//                     </p>
//                   )}

//                   <p>
//                     <b>{t("resstatus")}:</b> {issue.status}
//                   </p>
//                 </div>
//               )}

//             </div>
//           )}
//         </div>
//       </div>

//       {/* RIGHT PANEL */}
//       {/* <div className="col-md-4">
//         <div className="card issue_card h-100">
//           <h6 className="section_title">{t("resrecent_activity")}</h6>

//           {issue && (
//             <>
//               <div className="oi-activity">
//                 <b>{t("resissue_reported")}</b>
//                 <small>
//                   {new Date(issue.reported_at).toLocaleString()}
//                 </small>
//               </div>

//               <div className="oi-activity">
//                <b>{t("resissue_under_review")}</b>
//                 <small>{t("reswaiting_supplier")}</small>
//               </div>

//               {issue.resolved_at && (
//                 <div className="oi-activity">
//                   <b>{t("resissue_resolved")}</b>
//                   <small>
//                     {new Date(issue.resolved_at).toLocaleString()}
//                   </small>
//                 </div>
//               )}
//             </>
//           )}

//           <div className="support_box">
//             <i className="fa fa-headset support_icon"></i>
//             <p className="fw-bold mb-1">{t("resneed_help")}</p>

//             <a
//               href={`tel:${issue?.supplier_phone}`}
//               className="btn btn-outline-orange btn-sm"
//             >
//               {t("rescontact_support")}
//             </a>
//           </div>
//         </div>
//       </div> */}
//       <div className="col-md-4">
//   <div className="card issue_card h-100">

    
//  <div class="grn-info-item detail-row">
//               <div class="grn-info-icon supplier">
//                <i className="fa-regular fa-clock"></i>
//               </div>
//               <div class="grn-info-content">
//                 <div class="grn-info-value">{t("resrecent_activity")}
//                 </div>
//               </div>
//             </div>

//     {issue && (
//       <div className="activity_timeline">

//         <div className="timeline_item active">
//           <span className="timeline_dot"></span>

//           <div className="timeline_content">
//             <h6>{t("resissue_reported")}</h6>

//             <p>
//               {new Date(
//                 issue.reported_at
//               ).toLocaleString()}
//             </p>
//           </div>
//         </div>

//         <div className="timeline_item active">
//           <span className="timeline_dot"></span>

//           <div className="timeline_content">
//             <h6>{t("resissue_under_review")}</h6>

//             <p>
//               {t("reswaiting_supplier")}
//             </p>
//           </div>
//         </div>

//         <div className="timeline_item">
//           <span className="timeline_dot"></span>

//           <div className="timeline_content">
//             <h6>{t("ressupplier_response")}</h6>

//             <p>
//               {issue.action || "Pending"}
//             </p>
//           </div>
//         </div>

//         <div
//           className={`timeline_item ${
//             issue.resolved_at ? "active" : ""
//           }`}
//         >
//           <span className="timeline_dot"></span>

//           <div className="timeline_content">
//             <h6>{t("resissue_resolved")}</h6>

//             <p>
//               {issue.resolved_at
//                 ? new Date(
//                     issue.resolved_at
//                   ).toLocaleString()
//                 : "Pending"}
//             </p>
//           </div>
//         </div>

//       </div>
//     )}

  
//   </div>
// </div>

// <div className="support_card_new issue_card">

//   <div className="support_left">

  
//     <div className="support_icon_wrap">
//       <i className="fa-solid fa-headset"></i>
//     </div>
      

//     <div className="support_content1">

//       <h4>{t("resneed_help")}</h4>

//       <h6>Support Team Available</h6>

//       <p>
//         Our support team is here to help you resolve this issue.
//       </p>

//       <div className="support_time">
//         <i className="fa-regular fa-clock"></i>
//         <span>Average Response Time: &lt; 24 hrs</span>
//       </div>

//     </div>

//   </div>

//   <a
//     href={`tel:${issue?.supplier_phone}`}
//     className="support_btn"
//   >
//     <i className="fa-solid fa-headset me-2"></i>
//     {t("rescontact_support")}
//   </a>

// </div>
//     </div>
//   </div>
// );
// }



import React, { useEffect, useState } from "react";
// import "../css/OrderIssue.css";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const API = "https://api.mahal.qa/api/v1/orders";

export default function OrderIssue() {
  const [orderItems, setOrderItems] = useState([]);

  const { orderId } = useParams();
  const navigate = useNavigate();
  const [issue, setIssue] = useState(null);
  const [issueType, setIssueType] = useState("Missing Items");
  const [desc, setDesc] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ MULTI PRODUCT SELECTION
  const [selectedProducts, setSelectedProducts] = useState([]);

  const token = localStorage.getItem("token");

  const previewIssueId = `IR-${new Date().getFullYear()}-${String(orderId).slice(-4)}`;
  const previewReportedAt = new Date().toISOString();
  const { t, i18n } = useTranslation();

  const formatNumber = (value) => {
    return new Intl.NumberFormat(
      i18n.language === "ar" ? "ar-QA" : "en-US"
    ).format(value);
  };

  const formatOrderId = (id) => {
    if (i18n.language !== "ar") return id;

    return id.replace(/\d/g, (d) =>
      new Intl.NumberFormat("ar-QA").format(d)
    );
  };

  // ===============================
  // LOAD ISSUE (IF EXISTS)
  // ===============================
  useEffect(() => {
    setLoading(true);

    fetch(`${API}/${orderId}/issue`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.issue_report_id) {
          setIssue({
            ...data,
            damaged_products: data.damaged_products || [],
            issue_images: data.issue_images || []
          });
        } else {
          setIssue(null);
        }
      })
      .catch(() => setIssue(null))
      .finally(() => setLoading(false));
  }, [orderId, token]);


  // ===============================
  // IMAGE HANDLERS
  // ===============================
  const handleImageChange = e => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setImages(prev => [...prev, ...files]);
  };

  const removeImage = index => {
    setImages(prev => prev.filter((_, i) => i !== index));
  };

  // ===============================
  // PRODUCT HANDLERS
  // ===============================
  const handleProductSelect = e => {
    const value = String(e.target.value);
    if (!value) return;

    setSelectedProducts(prev =>
      prev.includes(value) ? prev : [...prev, value]
    );

    e.target.value = "";
  };


  const removeProduct = product => {
    setSelectedProducts(prev => prev.filter(p => p !== product));
  };

  // ===============================
  // SUBMIT ISSUE
  // ===============================
  const submitIssue = async () => {
    if (!desc.trim()) {
      alert(t("resdescribe_issue_error"));
      return;
    }

    if (!selectedProducts.length) {
      alert(t("resselect_product_error"));
      return;
    }

    const formData = new FormData();
    formData.append("issue_type", issueType);
    formData.append("description", desc);

    selectedProducts.forEach(p => {
      formData.append("products", p);
    });

    images.forEach(file => {
      formData.append("images", file);
    });

    const res = await fetch(`${API}/${orderId}/issue`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    if (!res.ok) {
      alert(t("resissue_failed"));
      return;
    }

    const result = await res.json();

    // ✅ FIX: store product_name immediately after submit
    setIssue({
      issue_report_id: result.issue_report_id,
      issue_type: issueType,
      description: desc,
      status: "UNDER_REVIEW",
      reported_at: new Date().toISOString(),
      damaged_products: selectedProducts.map(p => ({
        product_id: p,
        product_name: p

      })),
      issue_images: images.map(file => URL.createObjectURL(file))
    });

    setImages([]);
    setDesc("");
    setSelectedProducts([]);
  };

  useEffect(() => {
    if (!orderId) return;

    fetch(
      `https://api.mahal.qa/api/v1/orders/restaurant/orders/${orderId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    )

      .then(res => res.json())
      .then(data => {
        console.log("ORDER ITEMS:", data);
        setOrderItems(data.items || []);
      })
      .catch(() => setOrderItems([]));
  }, [orderId, token]);


  if (loading) {
    return <div className="oi-page">Loading...</div>;
  }



  //   useEffect(() => {
  //   if (!orderId) return;

  //   fetch(`${API}/${orderId}`, {
  //     headers: { Authorization: `Bearer ${token}` }
  //   })
  //     .then(res => res.json())
  //     .then(data => setOrderItems(data.items || []))
  //     .catch(() => setOrderItems([]));
  // }, [orderId, token]);

  return (
    <div className="dashboard_page order_issue_page">

      {/* HEADER */}
      <div className="page_header">
        <h2>



          {t("resorder_issue_details")}
        </h2>
        <button className="btn_add_item_v2" onClick={() => navigate(-1)}>
          ← {t("resback_to_orders")}
        </button>
      </div>


      {/* SUMMARY STRIP */}
      {/* <div className="issue_summary_strip">
      <div>
        <label>{t("resissue_report_id")}</label>
        {formatOrderId(issue ? issue.issue_report_id : previewIssueId)}
      </div>

      <div>
        <label>{t("resorder_id")}</label>
        <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
        {formatOrderId(orderId)}
      </span>
      </div>

      <div>
        <label>{t("resreported_on")}</label>
        <span>
          {new Date(issue?.reported_at || previewReportedAt).toLocaleString(i18n.language === "ar" ? "ar-QA" : "en-US")}
        </span>
      </div>
    </div> */}




      <div className="section_card soft mb-3">
        <div className="row">
          {/* issue_report_id */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon supplier">
                <i className="far fa-file-alt"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("resissue_report_id")}
                </small>

                <div className="grn-info-value">
                  {formatOrderId(issue ? issue.issue_report_id : previewIssueId)}
                </div>
              </div>
            </div>

          </div>

          {/* order_id */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon user">
                <i className="fas fa-dice-d6"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("resorder_id")}
                </small>

                <div className="grn-info-value" dir="ltr" style={{ unicodeBidi: "isolate" }}>
                  {formatOrderId(orderId)}
                </div>
              </div>
            </div>
          </div>
          {/* reported_on */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon date">
                <i className="far fa-calendar-alt"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("resreported_on")}
                </small>

                <div className="grn-info-value">
                  {new Date(issue?.reported_at || previewReportedAt).toLocaleString(i18n.language === "ar" ? "ar-QA" : "en-US")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="row mt-4">

        {/* LEFT PANEL */}
        <div className="col-md-8">
          <div className="card issue_card">
            <div class="grn-info-item detail-row">
              <div class="grn-info-icon supplier">
                <i class="fas fa-file-medical-alt"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">{t("resissue_information")}
                </div>
              </div>
            </div>

            {!issue && (
              <>
                <div className="summary_item detail-row">
                  <i class="fas fa-cube" aria-hidden="true"></i>
                  <div>
                    <p>{t("resissue_type")}:</p>
                    <select
                      className="form-select"
                      value={issueType}
                      onChange={(e) => setIssueType(e.target.value)}
                    >
                      <option>{t("resmissing_items")}</option>
                      <option>{t("resdamaged_items")}</option>
                      <option>{t("reswrong_items")}</option>
                    </select>
                  </div>
                </div>

                <div className="summary_item detail-row ">
                  <i class="fas fa-bolt" aria-hidden="true"></i>
                  <div>
                    <p>{t("resdamaged_products")}:</p>
                    <select
                      className="form-select"
                      onChange={handleProductSelect}
                    >
                      <option value="">{t("resselect_product")}</option>
                      {orderItems.map((item) => (
                        <option
                          key={item.product_name_english}
                          value={item.product_name_english}
                        >
                          {i18n.language === "ar"
                            ? item.product_name_arabic || item.product_name_english
                            : item.product_name_english}
                        </option>
                      ))}

                    </select>

                    {selectedProducts.length > 0 && (
                      <div className="oi-selected-products mb-3">
                        {selectedProducts.map((pid, idx) => {
                          const product = orderItems.find(
                            (i) => i.product_name_english === pid
                          );

                          return (
                            <span key={idx} className="oi-product-chip">
                              {product
                                ? (i18n.language === "ar"
                                  ? product.product_name_arabic || product.product_name_english
                                  : product.product_name_english)
                                : pid}
                              <button
                                type="button"
                                onClick={() => removeProduct(pid)}
                              >
                                ✕
                              </button>
                            </span>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="summary_item detail-row">
                <label className="form-label">{t("resdamaged_products")}</label>
                <select
                  className="form-select"
                  onChange={handleProductSelect}
                >
                  <option value="">{t("resselect_product")}</option>
                  {orderItems.map((item) => (
                    <option
                      key={item.product_name_english}
                      value={item.product_name_english}
                    >
                        {i18n.language === "ar"
                          ? item.product_name_arabic || item.product_name_english
                          : item.product_name_english}
                    </option>
                  ))}
                </select>
                   {selectedProducts.length > 0 && (
                <div className="oi-selected-products mb-3">
                  {selectedProducts.map((pid, idx) => {
                    const product = orderItems.find(
                      (i) => i.product_name_english === pid
                    );

                    return (
                      <span key={idx} className="oi-product-chip">
                        {product
                          ? (i18n.language === "ar"
                              ? product.product_name_arabic || product.product_name_english
                              : product.product_name_english)
                          : pid}
                        <button
                          type="button"
                          onClick={() => removeProduct(pid)}
                        >
                          ✕
                        </button>
                      </span>
                    );
                  })}
                </div>
              )}

              </div> */}


                <div className="mb-4">
                  <label className="form-label">{t("resdescription")}</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder={t("resdescribe_issue")}
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                  ></textarea>
                </div>


                <div className="mb-3">
                  <input
                    id="issueImage"
                    type="file"
                    accept="image/*"
                    multiple
                    className="d-none"
                    onChange={handleImageChange}
                  />

                  <button
                    type="button"
                    className="choose_file_btn"
                    onClick={() =>
                      document.getElementById("issueImage").click()
                    }
                  >
                    <i className="fa fa-camera me-2"></i>
                    {t("resadd_photos")}
                  </button>
                </div>

                {images.length > 0 && (
                  <div className="oi-image-preview mb-3">
                    {images.map((file, idx) => (
                      <div key={idx} className="oi-image-thumb">
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`preview-${idx}`}
                        />
                        <button
                          type="button"
                          className="oi-image-remove"
                          onClick={() => removeImage(idx)}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="action_buttons d-flex">
                  <button className="btn btn-orange" onClick={submitIssue}>
                    <i className="fa fa-paper-plane me-2"></i>
                    {t("ressubmit_issue")}
                  </button>
                </div>
              </>
            )}

            {issue && (
              <div className="oi-issue-view">


                <div className="summary_item detail-row">
                  <i class="fas fa-cube" aria-hidden="true"></i>
                  <div>
                    <p>{t("resproducts")}:</p>
                    {issue.damaged_products.map((p, idx) => {
                      const product = orderItems.find(
                        (i) => i.product_id === p.product_id
                      );

                      const name =
                        i18n.language === "ar"
                          ? product?.product_name_arabic || product?.product_name_english
                          : product?.product_name_english;

                      return (
                        <span key={idx} className="oi-product-chip">
                          {name}
                        </span>
                      );
                    })}
                  </div>
                </div>

                <div className="summary_item detail-row">
                  <i class="fas fa-comment-dots" aria-hidden="true"></i>
                  <div>
                    <p >{t("resdescription")}:</p>
                    <p>{issue.description}</p>
                  </div>
                </div>

                {issue.issue_images
                  ?.filter((img) => typeof img === "string" && img.length > 0)
                  .length > 0 && (
                    <div >
                      {issue.issue_images
                        .filter((img) => typeof img === "string" && img.length > 0)
                        .map((img, idx) => (
                          <div key={idx} className="oi-image-thumb">
                            <img
                              src={
                                img.startsWith("blob:")
                                  ? img
                                  : `data:image/jpeg;base64,${img}`
                              }
                              alt={`issue-${idx}`}
                            />
                          </div>
                        ))}
                    </div>
                  )}

                {issue.status !== "UNDER_REVIEW" && (
                  <div className="oi-field oi-supplier-response mt-3">
                    <h6>{t("ressupplier_response")}</h6>

                    {issue.action && (
                      <p>
                        <b>{t("resaction")}:</b> {issue.action}
                      </p>
                    )}

                    {issue.refund !== null && (
                      <p>
                        <b>{t("resrefund")}:</b> ${formatNumber(issue.refund)}
                      </p>
                    )}

                    {issue.notes && (
                      <p>
                        <b>{t("resnotes")}:</b> {issue.notes}
                      </p>
                    )}

                    <p>
                      <b>{t("resstatus")}:</b> {issue.status}
                    </p>
                  </div>
                )}

              </div>
            )}
          </div>
        </div>

        {/* RIGHT PANEL */}
        {/* <div className="col-md-4">
        <div className="card issue_card h-100">
          <h6 className="section_title">{t("resrecent_activity")}</h6>

          {issue && (
            <>
              <div className="oi-activity">
                <b>{t("resissue_reported")}</b>
                <small>
                  {new Date(issue.reported_at).toLocaleString()}
                </small>
              </div>

              <div className="oi-activity">
               <b>{t("resissue_under_review")}</b>
                <small>{t("reswaiting_supplier")}</small>
              </div>

              {issue.resolved_at && (
                <div className="oi-activity">
                  <b>{t("resissue_resolved")}</b>
                  <small>
                    {new Date(issue.resolved_at).toLocaleString()}
                  </small>
                </div>
              )}
            </>
          )}

          <div className="support_box">
            <i className="fa fa-headset support_icon"></i>
            <p className="fw-bold mb-1">{t("resneed_help")}</p>

            <a
              href={`tel:${issue?.supplier_phone}`}
              className="btn btn-outline-orange btn-sm"
            >
              {t("rescontact_support")}
            </a>
          </div>
        </div>
      </div> */}
        <div className="col-md-4">
          <div className="card issue_card h-100">


            <div class="grn-info-item detail-row">
              <div class="grn-info-icon supplier">
                <i className="fa-regular fa-clock"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">{t("resrecent_activity")}
                </div>
              </div>
            </div>

            {issue && (
              <div className="activity_timeline">

                <div className="timeline_item active">
                  <span className="timeline_dot"></span>

                  <div className="timeline_content">
                    <h6>{t("resissue_reported")}</h6>

                    <p>
                      {new Date(
                        issue.reported_at
                      ).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="timeline_item active">
                  <span className="timeline_dot"></span>

                  <div className="timeline_content">
                    <h6>{t("resissue_under_review")}</h6>

                    <p>
                      {t("reswaiting_supplier")}
                    </p>
                  </div>
                </div>

                <div className="timeline_item">
                  <span className="timeline_dot"></span>

                  <div className="timeline_content">
                    <h6>{t("ressupplier_response")}</h6>

                    <p>
                      {issue.action || "Pending"}
                    </p>
                  </div>
                </div>

                <div
                  className={`timeline_item ${issue.resolved_at ? "active" : ""
                    }`}
                >
                  <span className="timeline_dot"></span>

                  <div className="timeline_content">
                    <h6>{t("resissue_resolved")}</h6>

                    <p>
                      {issue.resolved_at
                        ? new Date(
                          issue.resolved_at
                        ).toLocaleString()
                        : "Pending"}
                    </p>
                  </div>
                </div>

              </div>
            )}


          </div>
        </div>

        <div className="support_card_new issue_card">

          <div className="support_left">


            <div className="support_icon_wrap">
              <i className="fa-solid fa-headset"></i>
            </div>


            <div className="support_content1">

              <h4>{t("resneed_help")}</h4>

              <h6>Support Team Available</h6>

              <p>
                Our support team is here to help you resolve this issue.
              </p>

              <div className="support_time">
                <i className="fa-regular fa-clock"></i>
                <span>Average Response Time: &lt; 24 hrs</span>
              </div>

            </div>

          </div>

          <a
            href={`tel:${issue?.supplier_phone}`}
            className="support_btn"
          >
            <i className="fa-solid fa-headset me-2"></i>
            {t("rescontact_support")}
          </a>

        </div>
      </div>
    </div>
  );
}